import React, { memo } from 'react';
import { initials } from '../lib/catalog';

/**
 * Portrait cliquable — distribution d'un titre, rail « têtes d'affiche »,
 * résultats de recherche par acteur.
 *
 * @param {string}   name
 * @param {string}   [photo]      URL TMDB ; à défaut, initiales sur médaillon
 * @param {string}   [role]       personnage ou fonction
 * @param {string}   [note]       ligne secondaire (« 4 films ici »)
 * @param {Function} onOpen
 */
function PersonCard({ name, photo, role, note, onOpen, index = 0 }) {
  return (
    <button
      type="button"
      className="person"
      style={{ '--i': index }}
      onClick={() => onOpen && onOpen(name)}
    >
      <span className="person-face">
        {photo ? (
          <img src={photo} alt="" loading="lazy" decoding="async" />
        ) : (
          <span className="person-initials" aria-hidden="true">
            {initials(name)}
          </span>
        )}
      </span>
      <span className="person-name clamp-2">{name}</span>
      {role && <span className="person-role clamp-1">{role}</span>}
      {note && <span className="person-note">{note}</span>}
    </button>
  );
}

export default memo(PersonCard);
